import React from "react";
import { useCurrentShipmentType } from "../../hooks/useCurrentShipmentType";

const useNotEnable = () => {
    const { customJobState, currentJobState } = useCurrentShipmentType()

    return React.useMemo(() => {
        return (customJobState.includes('NOT') && (currentJobState.includes("IN_PROCESS") || currentJobState.includes("READY"))) ? false : null;
    }, [customJobState,currentJobState])
}
 
export default useNotEnable;